


















import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";

@Component({
    components: {
        MainNavigation
    },
})

export default class Update extends Vue {
    mounted() {
        this.redirect(this.$route.params.toLocation)
    }

    async redirect(routeName: string) {
        await this.$nextTick();
        //await Vue.nextTick();
        this.$router.push({name: routeName})
    }
}
